module.exports = __webpack_public_path__ + "static/media/wxXtotast.1577724e.png";